import { render, staticRenderFns } from "./StudentFeeding.vue?vue&type=template&id=709e328d&"
import script from "./StudentFeeding.vue?vue&type=script&lang=js&"
export * from "./StudentFeeding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports